// test2012
(2012 && 0);
